import React, { useContext, useEffect, useRef, useState } from "react";

import { formatPrice, formatDate } from "../../../utils/Common";

import manIcon from "../../../assets/images/man.png";
import callenderIcon from "../../../assets/images/calendar.png";
import downloadIcon from "../../../assets/images/download.png";
import callIcon from "../../../assets/images/social/call.png";
import message1Icon from "../../../assets/images/social/message1.png";
import message2Icon from "../../../assets/images/social/message2.png";
import whatsappIcon from "../../../assets/images/social/whatsapp.png";
import { AppContext } from "../../../context/context";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal } from "../../../utils/Modal";
import { GrFormClose } from "react-icons/gr";
import DatePicker from "react-datepicker";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { FlashMessage } from "../../../utils/FlashMessage";
import ItemSelectBox from '../../../forms/ItemSelectBox';

const PaymentInfo = (props) => {
  const {
    hideModal,
    setSuccessFlashMessage,
    dueCollectionData,
    type,
    activeTab,
    loadingCallback,
    fetchedData,
    invoiceData,
    onSubmitPayment,
    handleSubmitAddDue,
    handleSubmitAddPiad,
    handlePrintPdf,
    setFromDate,
    setToDate,
    fromDate,
    toDate,
    reportBtn,
    getCustomerProfileData,
  } = props;
  const { state, updatePaymentList } = useContext(AppContext);

  console.log(dueCollectionData);

  //---------------------
  const location = useLocation();
  const navigate = useNavigate();
  const [hasPermission, setHasPermission] = useState(false);
  useEffect(() => {
    const employeeApiResponse = localStorage.getItem("employee");

    if (!employeeApiResponse || type === "customer" || type === "vendor") {
      setHasPermission(true);
      return; // Exit useEffect early
    }

    if (employeeApiResponse) {
      // Parse the employee data from local storage
      const employeeData = JSON.parse(employeeApiResponse);

      // Get the "Exporter" feature from the employee's role features
      const exporterFeature = employeeData.role.features.find(
        (feature) => feature.name === "Exporter"
      );

      // Check if the "Exporter" feature and "Visible" option are both active
      if (exporterFeature && exporterFeature.status === 1) {
        const exporterVisibleOption = exporterFeature.feature_options.find(
          (option) => option.name === "Visible" && option.status === 1
        );
        // Check if the "Hidden" option is active for /editproduct/:id route
        const exporterHiddenOption = exporterFeature.feature_options.find(
          (option) => option.name === "Hidden" && option.status === 1
        );

        // Grant access based on the route and permissions
        if (
          location.pathname === "/exporter-profile/:id" &&
          exporterVisibleOption
        ) {
          setHasPermission(true);
          return; // Exit useEffect if permission is granted
        }
        if (
          location.pathname === "/carrier-profile/:id" &&
          exporterVisibleOption
        ) {
          setHasPermission(true);
          return; // Exit useEffect if permission is granted
        }
      }
      setHasPermission(false);
      // If no permission, navigate to dashboard first
      navigate("/dashboard", { replace: true });
      setTimeout(() => {
        Swal.fire({
          icon: "error",
          title: "Permission Denied",
          text: "You do not have permission for this feature.",
        });
      }, 100);
    }
    // If not an employee, the useEffect gets skipped
  }, [navigate, location]);
  //---------------------

  const [paidAmount, setPaidAmount] = useState(0.0);

  const [openingAmount, setOpeningAmount] = useState(0);
  const [showDueDiscountModal, setShowDueDiscountModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [showPaymentEditModal, setShowPaymentEditModal] = useState(false);
  const [selectedDuePayment, setSelectedDuePayment] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const [showAddPaymentModal, setShowAddPaymentModal] = useState(false);
  const [showOpeningBalanceModal, setShowOpeningBalanceModal] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const [paymentList, setPaymentList] = useState([]);
  const [paymentAccountList, setPaymentAccountList] = useState([]);
  const [filteredAccountList, setFilteredAccountList] = useState([]);
  const [selectedPaymentAccountList, setSelectedPaymentAccountList] = useState(
    []
  );
  const [selectedAddPaymentAccountList, setSelectedAddPaymentAccountList] =
    useState([]);
  const [warningMessage, setWarningMessage] = useState("");
  const [customerDueInvoiceListState, setCustomerDueInvoiceListState] =
    useState([]);
  const {
    setCustomerDueInvoiceList,
    setVendorDueInvoiceList,
    setExporterDueInvoiceList,
    setCarrierDueInvoiceList,
    setWholesellerDueInvoiceList,
  } = useContext(AppContext);
  const {
    saleInvoiceIdForDue,
    purchaseInvoiceIdForDue,
    exporterInvoiceIdForDue,
    carrierInvoiceIdForDue,
    wholesellerInvoiceIdForDue,
    duePaymentCustomDate,
    vendorDueInvoiceList,
  } = state;
  const [money, setMoney] = useState("");
  const token = localStorage.getItem("token");
  const { id } = useParams();
  //const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState("");
  const perPage = 1000;

  const [formData, setFormData] = useState({
    name: "",
    method_id: 0,
    account_id: 0,
    account_number: "",
    methodLabel: "",
    accountLabel: "",
  });

  const datePickerRef2 = useRef(null);
  const [transactionDate, setTransactionDate] = useState(new Date);
  const handleDivClick2 = () => {
    if (datePickerRef2.current) {
      datePickerRef2.current.setOpen(true); // Programmatically open the date picker
    }
  };

  const [paymentAccountAmount, setPaymentAccountAmount] = useState([{
    methodName: '',
    AccountName: "",
    account_number: "",
    payment_type_id: '',
    payment_type_category_id: '',
    Amount: '',
  }]);
  const [methodIndex, setMethodIndex] = useState(null)

  const getWholesellerDueInvoiceList = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}wholeseller-due-invoice-list/${id}`,
        {
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setWholesellerDueInvoiceList(response.data.data);
          console.log(response.data.data);
        }
      })
      .catch((error) => {
        // navigate('/login');
        console.log(error);
      });
  };

  const getCarrierDueInvoiceList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}carrier-due-invoice-list/${id}`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setCarrierDueInvoiceList(response.data.data);
          console.log(response.data.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        console.log(error);
      });
  };

  const getExporterDueInvoiceList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}exporter-due-invoice-list/${id}`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setExporterDueInvoiceList(response.data.data);
          console.log(response.data.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        console.log(error);
      });
  };

  const getVendorDueInvoiceList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}vendor-due-invoice-list/${id}`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setVendorDueInvoiceList(response.data.data);
          console.log(response.data.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        console.log(error);
      });
  };

  const getCustomerDueInvoiceList = () => {
    loadingCallback(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}customer-due-invoice-list/${id}`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setCustomerDueInvoiceList(response.data.data);
          setCustomerDueInvoiceListState(response.data.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        console.log(error);
      });
  };

  const getPayment = () => {
    loadingCallback(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}payment-type-list`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          const selectedAccount = response?.data?.data?.data?.find(
            (method) => method.type_name.toLowerCase() == "cash"
          );
          console.log("Selected account inpayment data...............",selectedAccount)
          setPaymentData([...paymentData, selectedAccount]);
          updatePaymentList(response?.data?.data);
          setPaymentList(response?.data?.data?.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        console.log(error);
      });
  };

  useEffect(() => {
    if (type === "customer") {
      getCustomerDueInvoiceList();
    }
  }, [showPaymentModal, showDueDiscountModal]);

  useEffect(() => {
    setTimeout(() => {
      if (type === "exporter") {
        getExporterDueInvoiceList();
      }

      if (type === "vendor") {
        getVendorDueInvoiceList();
      }

      if (type === "customer") {
        console.log("Called");
        getCustomerDueInvoiceList();
        getCustomerProfileData(activeTab);
      }
      if (type === "carrier") {
        getCarrierDueInvoiceList();
      }
      if (type === "wholesaler") {
        getWholesellerDueInvoiceList();
      }
    }, 1000);
  }, [showDueDiscountModal]);

  useEffect(() => {
    if (hasPermission) {
      getPayment();
      getPaymentAccountList();
    }
  }, [hasPermission]);
  useEffect(() => {
    if (hasPermission) {
      submitDuePayment(selectedPaymentAccountList);
    }
  }, [selectedPaymentAccountList, hasPermission]);
  useEffect(() => {
    setShowPaymentModal(false);
  }, [hideModal]);
  const submitDuePayment = async (selectedPaymentAccountList) => {
    console.log(type);
    if (selectedPaymentAccountList.length > 0) {
      setShowPaymentModal(!showPaymentModal);
      const paymentMap = selectedPaymentAccountList.map((item) => ({
        payment_type_id: item?.payment_type_id,
        payment_type_category_id: item?.payment_type_category_id,
        payment_amount: item?.Amount,
      }));
      const data = {
        previous_due:
          type != "carrier"
            ? fetchedData?.invoice_list_sum_sub_total -
              fetchedData?.invoice_list_sum_paid_amount
            : 0,
        paid_amount: Number(paidAmount),
        payment_method: paymentMap,
        sale_invoice_id: saleInvoiceIdForDue,
        purchase_invoice_id: purchaseInvoiceIdForDue,
        exporter_invoice_id: exporterInvoiceIdForDue,
        carrier_invoice_id: carrierInvoiceIdForDue,
        wholesale_invoice_id: wholesellerInvoiceIdForDue,
        custom_date: duePaymentCustomDate,
      };
      if (type === "vendor") {
        data.vendor_id = fetchedData?.id;
      }
      if (type === "wholesaler") {
        data.wholesaler_id = fetchedData?.id;
      }
      if (type === "customer") {
        data.customer_id = fetchedData?.id;
      }
      if (type === "exporter") {
        data.exporter_id = fetchedData?.id;
      }
      if (type === "carrier") {
        data.carrier_id = fetchedData?.id;
      }
      // console.log("============");
      // console.log(data);

      onSubmitPayment(data);

      setTimeout(() => {
        if (type === "exporter") {
          getExporterDueInvoiceList();
        }

        if (type === "vendor") {
          getVendorDueInvoiceList();
        }

        if (type === "customer") {
          getCustomerDueInvoiceList();
        }
        if (type === "carrier") {
          getCarrierDueInvoiceList();
        }
        if (type === "wholesaler") {
          getWholesellerDueInvoiceList();
        }
      }, 1000);
    }
  };
  const getPaymentAccountList = () => {
    loadingCallback(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}payment-type-category-list`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response?.data.success) {
          loadingCallback(false);
          setPaymentAccountList(response?.data?.data?.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        console.log(error);
      });
  };
  const handleClicks = (data) => {
    setShowPaymentModal(true);
  };

  const handleDueDiscountClick = () => {
    setShowDueDiscountModal(true);
  };

  const handleOpeningBalanceClicks = () => {
    setShowOpeningBalanceModal(!showOpeningBalanceModal);
  };

  const handleOpeningBalanceSubmit = async (selectedAddPaymentAccountList) => {
    if (selectedAddPaymentAccountList.length > 0) {
      setShowPaymentModal(!showPaymentModal);
      const paymentMap = selectedAddPaymentAccountList.map((item) => ({
        payment_type_id: item?.payment_type_id,
        payment_type_category_id: item?.payment_type_category_id,
        payment_amount: item?.Amount,
      }));
      const data = {
        adv_amount: Number(paidAmount),
        payment_method: paymentMap,
      };
      if (type === "vendor") {
        data.vendor_id = fetchedData?.id;
      }
      if (type === "wholesaler") {
        data.wholesaler_id = fetchedData?.id;
      }
      if (type === "customer") {
        data.customer_id = fetchedData?.id;
      }
      if (type === "exporter") {
        data.exporter_id = fetchedData?.id;
      }
      handleSubmitAddPiad(data);
    }
  };

  const handleOpeningPaidModal = () => {
    // setShowOpeningBalanceModal(true);
    setShowAddPaymentModal(true);
  };

  const handleOpeningDueBalanceSubmit = () => {
    setShowOpeningBalanceModal(!showOpeningBalanceModal);
    const data = {
      adv_amount: Number(openingAmount),
    };
    if (type === "vendor") {
      data.vendor_id = fetchedData?.id;
    }
    if (type === "wholesaler") {
      data.wholesaler_id = fetchedData?.id;
    }
    if (type === "customer") {
      data.customer_id = fetchedData?.id;
    }
    if (type === "exporter") {
      data.exporter_id = fetchedData?.id;
    }
    handleSubmitAddDue(data);
  };

  useEffect(() => {
    handleOpeningBalanceSubmit(selectedAddPaymentAccountList);
    setShowOpeningBalanceModal(false);
    setShowAddPaymentModal(false);
  }, [selectedAddPaymentAccountList]);

  // useEffect(() => {
  //   submitAddDuePayment(selectedPaymentAccountList);
  // }, [selectedPaymentAccountList]);

  useEffect(() => {
    console.log("show opening valanace modal", showOpeningBalanceModal);
  }, [showAddPaymentModal]);

  const [fromDateIsOpen, setFromDateIsOpen] = useState(false);
  const [toDateIsOpen, setToDateIsOpen] = useState(false);

  const handleFromDateChange = (date) => setFromDate(date);
  const handleToDateChange = (date) => setToDate(date);

  const toggleFromDate = () => setFromDateIsOpen(!fromDateIsOpen);
  const toggleToDate = () => setToDateIsOpen(!toDateIsOpen);

  const closeAllPickers = () => {
    setFromDateIsOpen(false);
    setToDateIsOpen(false);
  };

  // Handle document click outside the date pickers (optional)
  //document.addEventListener('click', closeAllPickers, false); // Remove event listener on unmount
  useEffect(() => {
    if (reportBtn) {
      handlePrintPdf("duepayReport");
    }
  }, [reportBtn]);

  const handleReportButton = () => {
    //props.setReportBtn(true);
    props.getDateWiseDueReport(1);
  };

  const [editIndex, setEditIndex] = useState(null);
  const [editedData, setEditedData] = useState({});

  const handleEditClick = (index, initialValue) => {
    setEditIndex(index);
    setEditedData({ ...editedData, [index]: initialValue });
  };

  const handleInputChange = (index, value) => {
    setEditedData({ ...editedData, [index]: value });
  };

  const formatDateForBackend = (date) => {
    if (!date) return null;

    // Case 1: Date object
    if (date instanceof Date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }

    // Case 2: String like "30 Dec, 2025"
    if (typeof date === "string") {
      const [day, month, year] = date.replace(",", "").split(" ");

      const months = {
        Jan: "01", Feb: "02", Mar: "03", Apr: "04",
        May: "05", Jun: "06", Jul: "07", Aug: "08",
        Sep: "09", Oct: "10", Nov: "11", Dec: "12",
      };

      return `${year}-${months[month]}-${day.padStart(2, "0")}`;
    }

    return null;
  };

  const handleSaveClick = (item) => {

    const totalAmount = paymentAccountAmount.reduce(
      (sum, item) => sum + Number(item.Amount || 0),
      0
    );
    const updatedValue =
      totalAmount ||
      (type === "carrier" || type === "exporter"
        ? item?.amount
        : item?.paid_amount);


    const multiplePayment = paymentAccountAmount.map((mp) => ({
      payment_type_id: mp.payment_type_id || '',
      payment_type_category_id: mp.payment_type_category_id || '',
      payment_amount: mp.Amount || 0
    }))

    const data = {
      id: item.id, // or `item.invoice_id` depending on your API requirement
      paid_amount: updatedValue, // key for the updated amount
      multiple_payment: multiplePayment,
      date: transactionDate
        ? formatDateForBackend(transactionDate)
        : null,
    };

    console.log("payload Data........ ",data)
    axios
      .post(
        `${process.env.REACT_APP_API_URL}update-due-collection/${item.id}`,
        data,
        {
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.success) {
          FlashMessage("Due collection updated successfully.", "success");
          setEditIndex(null); // Exit edit mode
          setShowPaymentEditModal(false);
          // Optionally, refresh the table or update state locally
          window.location.reload();
        } else {
          FlashMessage(
            response.data.message || "Something went wrong!",
            "error"
          );
        }
      })
      .catch((error) => {
        FlashMessage("Failed to update due collection.", "error");
        if (error?.response?.status === 401) {
          localStorage.clear();
          navigate("/login");
        }
      });
  };

  useEffect(() => {
    const selectedAccount = paymentList.find(
      (method) => method.type_name.toLowerCase() == "cash"
    );
    console.log("selectedAccount...............inside useeffect ", selectedAccount)
    if (selectedAccount) {
      setPaymentAccountAmount((prevAmount) => {
        if (!prevAmount.length) return [];

        return [
          {
            ...prevAmount[0],
            payment_type_id: selectedAccount.id,
            payment_type_category_id:
              selectedAccount.payment_type_category[0]?.id || "",
            methodName: selectedAccount.type_name,
          },
          ...prevAmount.slice(1), // ✅ keep the rest
        ];
      });
    }
  }, []);

  const handleChangeSelect = (name, option) => {
    const { value, label } = option;

    console.log("Option", name, option);
    console.log("PaymentList", paymentAccountList, paymentList);

    if (name === 'payment_id') {
      if (label !== 'Select Payment' && value) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          method_id: '',
          account_number: '',
        }));

        const selectedMethodObject = paymentList.find(
          (method) => method.id === value
        );

        if (selectedMethodObject) {
          setFilteredAccountList(selectedMethodObject.payment_type_category || []);
        } else {
          setFilteredAccountList([]);
        }

        const newArray = [...paymentData];
        newArray[methodIndex] = selectedMethodObject;
        setPaymentData(newArray);
        console.log("paymentAccountAmount inside change select ",paymentAccountAmount)
        console.log("newArray[methodIndex]............inside change select ",newArray[methodIndex])
        const newArray2 = [...paymentAccountAmount];
        newArray2[methodIndex] = {
          ...newArray2[methodIndex], // ✅ Preserve existing data
          payment_type_category_id: newArray[methodIndex].payment_type_category[0].id,
          account_number: newArray[methodIndex].payment_type_category[0].account_number,
          payment_type_id: value,
          methodName: label,
        };
        setPaymentAccountAmount(newArray2);
      }

      if (label === 'Select Payment') {
        setFormData((prevFormData) => ({
          ...prevFormData,
          account_id: '',
          account_number: '',
        }));
      }
    }

    else if (name === 'account_id') {
      if (label === 'Select Account') {
        setFormData((prevFormData) => ({
          ...prevFormData,
          account_id: '',
          account_number: '',
        }));

        const newArray = [...paymentAccountAmount];
        newArray[methodIndex] = {
          ...newArray[methodIndex], // ✅ Preserve previously saved values
          account_number: '',
          AccountName: '',
          payment_type_category_id: ''
        };
        setPaymentAccountAmount(newArray);
        // setFilteredAccountDetails({});
      }

      else {
        const selectedAccount = paymentAccountList.find(
          (method) => method.id === value
        );

        console.log("account", selectedAccount, methodIndex);
        if (selectedAccount) {
          const newArray = [...paymentAccountAmount];
          newArray[methodIndex] = {
            ...newArray[methodIndex], // ✅ Keep other values intact
            AccountName: label,
            account_number: selectedAccount?.account_number,
            payment_type_category_id: value
          };
          setPaymentAccountAmount(newArray);
          // setFilteredAccountDetails(selectedAccount);
        }
      }
    }
  };

  const amountData = {
    methodName: "cash",
    AccountName: "",
    account_number: "",
    payment_type_id: "",
    payment_type_category_id: "",
    Amount: '',
  }


  const handleAddMethod = async () => {
    if(paymentData.length < paymentList.length) {
      const selectedAccount = paymentList.find(
        (method) => method.type_name.toLowerCase() === "cash"
      );
      setPaymentData([...paymentData, selectedAccount]);
      const newArray = [...paymentAccountAmount];
      let data = {
        ...amountData,
        methodName: selectedAccount.type_name,
        payment_type_id: selectedAccount.id,
        payment_type_category_id: selectedAccount.payment_type_category[0]?.id || ""
      };
      setPaymentAccountAmount([...paymentAccountAmount, data]);
    }
  };

  const handleCancelMethod = (id, par) => {
    if(paymentData.length>1){
      const indexToRemove = paymentData.findIndex((item, index) => index === par);
      if (indexToRemove !== -1) {
        const newData = [...paymentData];
        newData.splice(indexToRemove, 1);
        setPaymentData(newData);
      }
      const indexToRemove2 = paymentAccountAmount.findIndex((item, index) => index === par);
      if (indexToRemove2 !== -1) {
        const newData2 = [...paymentAccountAmount];
        newData2.splice(indexToRemove2, 1);
        setPaymentAccountAmount(newData2);
      }
    }
  };

  return (
    <>
      <div className="bg-[#F8F9FA] rounded-[16px]">
        <div className="mb-[20px] flex flex-col items-center">
          <div
            className="w-[80px] rounded-[50%] p-[3px]"
            style={{
              boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
            }}
          >
            <img
              src={fetchedData?.image ? fetchedData?.image : manIcon}
              className="w-[100%] rounded-[50%]"
            />
          </div>
          <h2 className="font-lato font-[600] text-[18px] text-[#000232] mt-[20px]">
            {fetchedData?.name}
          </h2>
          <p className="font-nunito font-[700] text-[13px] text-[#7282A0] mt-[10px]">
            {fetchedData?.email}
          </p>
          {type === "vendor" ? (
            <Link
              className="font-nunito font-[600] text-[11px] text-[#1294F2] mt-[10px]"
              to={`/vendor-edit/${fetchedData.id}`}
            >
              Edit Vendor
            </Link>
          ) : type === "wholesaler" ? (
            <Link
              className="font-nunito font-[600] text-[11px] text-[#1294F2] mt-[10px]"
              to={`/wholesaler-edit/${fetchedData.id}`}
            >
              Edit Wholesaler
            </Link>
          ) : type === "customer" ? (
            <Link
              className="font-nunito font-[600] text-[11px] text-[#1294F2] mt-[10px]"
              to={`/customer-edit/${fetchedData.id}`}
            >
              Edit Customer
            </Link>
          ) : type === "exporter" ? (
            <Link
              className="font-nunito font-[600] text-[11px] text-[#1294F2] mt-[10px]"
              to={`/exporter-edit/${fetchedData.id}`}
            >
              Edit Exporter
            </Link>
          ) : type === "carrier" ? (
            <Link
              className="font-nunito font-[600] text-[11px] text-[#1294F2] mt-[10px]"
              to={`/carrier-edit/${fetchedData.id}`}
            >
              Edit Carrier
            </Link>
          ) : (
            ""
          )}
        </div>
        <div className="flex flex-row justify-between gap-1 max-w-[196px] m-auto mb-4">
          <img src={callIcon} width={40} height={40} alt="" />
          <img src={message1Icon} width={40} height={40} alt="" />
          <img src={message2Icon} width={40} height={40} alt="" />
          <img src={whatsappIcon} width={40} height={40} alt="" />
        </div>
        {showPaymentModal ? (
          <Modal
            isOpen={showPaymentModal}
            setOpen={setShowPaymentModal}
            dueAmount={
              type === "carrier" ||
              (type === "exporter" && fetchedData?.total_due)
                ? fetchedData.total_due.toFixed(2)
                : fetchedData?.due
                ? fetchedData.due.toFixed(2)
                : 0
            }
            getData={paymentData}
            listData={paymentList}
            formData={formData}
            setFormData={setFormData}
            paymentAccountList={paymentAccountList}
            setSelectedAccountList={setSelectedPaymentAccountList}
            setData={setPaymentData}
            setPaidAmount={setPaidAmount}
            setWarningMessage={setWarningMessage}
            title="Due Payment Info"
            formId="my_modal_due_payment"
            loadingCallback={loadingCallback}
            navigate={navigate}
            type="due-payment"
            selectType={type}
            setFilteredAccountList={setFilteredAccountList}
            filteredAccountList={filteredAccountList}
          />
        ) : null}

        {showDueDiscountModal ? (
          <Modal
            isOpen={showDueDiscountModal}
            setOpen={setShowDueDiscountModal}
            customerDueInvoiceListState={customerDueInvoiceListState}
            vendorDueInvoiceList={vendorDueInvoiceList}
            type="due-discount"
            formId="my_modal_due_discount"
            title="Due Discount"
            dueAmount={fetchedData?.due ? fetchedData.due.toFixed(2) : 0}
            dueType={type}
          />
        ) : null}

        {showAddPaymentModal ? (
          <Modal
            isOpen={showAddPaymentModal}
            setOpen={setShowAddPaymentModal}
            dueAmount={
              type === "carrier" && fetchedData?.total_due
                ? fetchedData.total_due.toFixed(2)
                : fetchedData?.due
                ? fetchedData.due.toFixed(2)
                : 0
            }
            getData={paymentData}
            listData={paymentList}
            formData={formData}
            setFormData={setFormData}
            paymentAccountList={paymentAccountList}
            setSelectedAccountList={setSelectedAddPaymentAccountList}
            setData={setPaymentData}
            setPaidAmount={setPaidAmount}
            setWarningMessage={setWarningMessage}
            title="Due Payment Info"
            formId="my_modal_payment"
            loadingCallback={loadingCallback}
            navigate={navigate}
            type="payment"
            selectType={type}
            setFilteredAccountList={setFilteredAccountList}
            filteredAccountList={filteredAccountList}
          />
        ) : null}

        {showOpeningBalanceModal ? (
          <>
            <div>
              <input
                type="checkbox"
                id="my_modal_openingBalance"
                className="modal-toggle"
              />
              <div className="modal">
                <div className="modal-box w-[490px] p-0 bg-white">
                  <div className="flex justify-between px-[18px] pt-[17px] pb-[13px] border-b border-[#D9D9D9]">
                    <h4 className="font-nunito font-semibold text-lg ">
                      Advance Paid
                    </h4>
                    <div className="modal-action">
                      <label
                        onClick={() =>
                          setShowOpeningBalanceModal(!showOpeningBalanceModal)
                        }
                        htmlFor="my_modal_openingBalance"
                        className="cursor-pointer modal-action bg-red-600 text-white rounded-md"
                      >
                        <GrFormClose />
                      </label>
                    </div>
                  </div>
                  <div className="px-5 pt-5 pb-[22px]">
                    {/* <form
                        method="post"
                        className="col-sm-12"
                        data-autosubmit="false"
                        autoComplete="off"
                        encType="multipart/form-data"
                      > */}
                    <div className="w-full relative">
                      <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[10px] left-[15px] bg-white px-1 font-semibold">
                        Amount
                      </label>
                      <input
                        type="text"
                        name="name"
                        onChange={(e) => {
                          setOpeningAmount(e.target.value);
                        }}
                        placeholder="000"
                        className="input input-bordered w-full mb-[15px] rounded-2xl bg-white"
                      />
                    </div>
                    <div className="button-disabled flex flex-row gap-2">
                      <button
                        // htmlFor='my_modal_openingBalance'
                        // type="submit"
                        onClick={handleOpeningDueBalanceSubmit}
                        className="cursor-pointer w-full border-2 border-[#034AFF] py-[12px] text-center rounded-2xl text-[#034AFF] font-lato font-semibold text-lg"
                      >
                        Add Due
                      </button>
                      <label
                        htmlFor="my_modal_payment"
                        // type="submit"
                        onClick={handleOpeningPaidModal}
                        className="cursor-pointer w-full bg-[#034AFF] py-[12px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
                      >
                        Add Paid
                      </label>
                    </div>
                    {/* </form> */}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}

        <div>
          {type !== "carrier" ? (
            <label
              htmlFor="my_modal_openingBalance"
              onClick={handleOpeningBalanceClicks}
              className="mb-4 w-[250px] cursor-pointer m-auto xl:w-[100%] bg-white mt-[15px] border-1 border-[#034AFF] rounded-[14px] block font-nunito font-[600] text-[18px] text-[#034AFF] px-1 py-2 text-center"
            >
              Opening Balance
            </label>
          ) : null}

          <label
            htmlFor="my_modal_due_payment"
            onClick={() => handleClicks(fetchedData)}
            className="mb-4 w-[250px] cursor-pointer m-auto xl:w-[100%] mt-[15px] border-1 border-[#034AFF] bg-[#034AFF] rounded-[14px] block font-nunito font-[600] text-[18px] text-white px-1 py-2 text-center"
          >
            Pay Due
          </label>

          <label
            htmlFor="my_modal_due_discount"
            onClick={() => handleDueDiscountClick()}
            className="mb-4 w-[250px] cursor-pointer m-auto xl:w-[100%] mt-[15px] border-1 border-[#034AFF] bg-[#034AFF] rounded-[14px] block font-nunito font-[600] text-[18px] text-white px-1 py-2 text-center"
          >
            Due Discount
          </label>
        </div>

        <div className="mt-[15px] border-1 border-[#CBD5E0] rounded-[16px] px-[10px] py-[15px] bg-white">
          <div className="flex justify-between mb-[10px]">
            <p className="font-nunito font-[700] text-[12px] text-[#000232]">
              Payment History
            </p>
            {type == "carrier" || type == "exporter" ? (
              <>
                <img
                  src={callenderIcon}
                  alt="From Date Calendar"
                  onClick={toggleFromDate}
                  className={`w-[20px] cursor-pointer ${
                    fromDateIsOpen ? "active" : ""
                  }`} // Optional styling for active icon
                />
                <span>To:</span>
                <img
                  src={callenderIcon}
                  alt="To Date Calendar"
                  onClick={toggleToDate}
                  className={`w-[20px] cursor-pointer ${
                    toDateIsOpen ? "active" : ""
                  }`} // Optional styling for active icon
                />
                <img
                  src={downloadIcon}
                  alt="To Date Calendar"
                  onClick={handleReportButton}
                  //onClick={() => handlePrintPdf('duepayReport')}
                  className={`w-[20px] cursor-pointer ${
                    toDateIsOpen ? "active" : ""
                  }`} // Optional styling for active icon
                />
              </>
            ) : null}
          </div>
          {fromDateIsOpen || toDateIsOpen ? (
            <div className="grid grid-cols-4 bg-white border-1 border-solid border-[#9B54E1] rounded-[16px] p-[5%]">
              <div className=" flex justify-between w-full col-span-7 items-center mt-[5px] md:mt-0 flex-col md:flex-row font-nunito gap-4">
                {fromDateIsOpen && (
                  <div className="relative border-[#C1CFEF] py-2.5 border w-full flex-1 rounded-xl">
                    <DatePicker
                      selected={fromDate}
                      onChange={handleFromDateChange}
                      dateFormat="yyyy-MM-dd" // Adjust date format as needed
                      // Other DatePicker props (e.g., minDate, maxDate)
                      onClose={closeAllPickers} // Close on date selection (optional)
                      className="w-full px-2 focus:outline-none"
                    />
                    <span className="bg-white absolute left-2 font-semibold px-1 text-xs top-0 text-[#102048] translate-y-[-50%]">
                      Start Date
                    </span>
                  </div>
                )}
              </div>
              <div className=" flex justify-between w-full col-span-7 items-center mt-[5px] md:mt-0 flex-col md:flex-row font-nunito gap-4">
                {toDateIsOpen && (
                  <div className="relative border-[#C1CFEF] py-2.5 border w-full flex-1 rounded-xl">
                    <DatePicker
                      selected={toDate}
                      onChange={handleToDateChange}
                      dateFormat="yyyy-MM-dd" // Adjust date format as needed
                      // Other DatePicker props (e.g., minDate, maxDate)
                      onClose={closeAllPickers} // Close on date selection (optional)
                      className="w-full px-2 focus:outline-none"
                    />
                    <span className="bg-white absolute left-2 font-semibold px-1 text-xs top-0 text-[#102048] translate-y-[-50%]">
                      To Date
                    </span>
                  </div>
                )}
              </div>
            </div>
          ) : null}

          <div class="grid grid-cols-6">
            <div class="font-lato font-[600] text-[10px] text-[#000232] py-[8px]">
              Date
            </div>
            <div class="font-nunito font-bold text-[10px] text-[#000232] py-[8px] text-center">
              INV.
            </div>
            <div class="font-nunito font-bold text-[10px] text-[#000232] py-[8px] text-center">
              Amount
            </div>
            {/* <div class="font-nunito font-bold text-[10px] text-[#000232] py-[8px] text-center">
              Paid for
            </div> */}
            <div class="font-nunito font-bold text-[10px] text-[#000232] py-[8px] text-center">
              Payment Type
            </div>
            <div class="font-nunito font-bold text-[10px] text-[#000232] py-[8px] text-center">
              PDF
            </div>
            <div class="font-nunito font-bold text-[10px] text-[#000232] py-[8px] text-right">
              Action
            </div>
          </div>

          {/* {dueCollectionData.length > 0 && dueCollectionData.map((item, index) => {

              return (
                <div
                  key={index}
                  class="border-t-[1px] border-solid border-[#E3EDF6] py-[8px] font-nunito font-[500] text-[10px] grid grid-cols-5 items-center"
                >
                  <div className="text-[#000232]">
                    {type == "carrier" || type == "exporter"
                      ? formatDate(item.date)
                      : formatDate(item.created_at)}
                  </div>
                  <div className="text-[#000232] text-center">
                    {type == "carrier" || type == "exporter"
                      ? item?.amount
                      : item?.paid_amount}
                  </div>
                  <div className="text-[#29B170] text-center">
                    {type == "carrier" || type == "exporter"
                      ? item?.paid_for
                      : "Bill Pay"}
                  </div>
                  <div className="text-center">
                    <a
                      href={
                        type === "carrier" &&
                        (item?.paid_for == "bill" || item?.paid_for == null)
                          ? `/carrier-invoice/${item.id}`
                          : type === "carrier" && item?.paid_for == "due"
                          ? `/carrier-due-invoice/${item.id}`
                          : type === "exporter" &&
                            (item?.paid_for == "bill" || item?.paid_for == null)
                          ? `/exporter-invoice/${item.id}`
                          : type === "exporter" && item?.paid_for == "due"
                          ? `/exporter-due-invoice/${item.id}`
                          : `/due-invoice/${item.invoice_id}`
                      }
                      className="text-[#034AFF]"
                    >
                      Invoice
                    </a>
                  </div>
                  <div className="text-right">
                      <button >
                          Edit
                      </button>
                  </div>
                </div>
              );
          })} */}

          {dueCollectionData.length > 0 &&
            dueCollectionData.map((item, index) => {
              const isEditable = editIndex === index;
              console.log("item in dueCollection........ ", item)

              return (
                <div
                  key={index}
                  className="border-t-[1px] border-solid border-[#E3EDF6] py-[8px] font-nunito font-[500] text-[10px] grid grid-cols-6 items-center"
                >
                  {/* Date */}
                  <div className="text-[#000232]">
                    {type === "carrier" || type === "exporter"
                      ? formatDate(item.date)
                      : formatDate(item.created_at)}
                  </div>
                  <div className="text-[#000232] text-center">
                    {item.invoice_id.includes('PUR') ? 'Purchase' : 'Due'}
                  </div>
                  {/* Editable Amount */}
                  <div className="text-[#000232] text-center">
                    {/* {isEditable ? (
                      <input
                        type="text"
                        className="border border-gray-300 rounded px-2 text-[10px]"
                        value={editedData[index] || ""}
                        onChange={(e) =>
                          handleInputChange(index, e.target.value)
                        }
                      />
                    ) : */ type === "carrier" || type === "exporter" ? (
                      item?.amount
                    ) : (
                      item?.paid_amount
                    )}
                  </div>

                  {/* Paid For */}
                  {/* <div className="text-[#29B170] text-center">
                    {type === "carrier" || type === "exporter"
                      ? item?.paid_for
                      : "Bill Pay"}
                  </div> */}
                  <div key={index} className="text-center">
                    {item?.payment_type}
                  </div>

                  {/* Invoice Link */}
                  <div className="text-center">
                    <a
                      href={
                        type === "carrier" &&
                        (item?.paid_for === "bill" || item?.paid_for == null)
                          ? `/carrier-invoice/${item.id}`
                          : type === "carrier" && item?.paid_for === "due"
                          ? `/carrier-due-invoice/${item.id}`
                          : type === "exporter" &&
                            (item?.paid_for === "bill" ||
                              item?.paid_for == null)
                          ? `/exporter-invoice/${item.id}`
                          : type === "exporter" && item?.paid_for === "due"
                          ? `/exporter-due-invoice/${item.id}`
                          : `/due-invoice/${item.invoice_id}`
                      }
                      className="text-[#034AFF]"
                    >
                      Invoice
                    </a>
                  </div>

                  {/* Edit Button */}
                  {/* <div className="text-right">
                    {isEditable ? (
                      <button
                        onClick={() => handleSaveClick(item)}
                        className="text-[#034AFF] text-xs"
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        onClick={() =>
                          handleEditClick(
                            index,
                            type === "carrier" || type === "exporter"
                              ? item?.amount
                              : item?.paid_amount
                          )
                        }
                        className="text-[#034AFF] text-xs hover:font-bold hover:underline"
                      >
                        Edit
                      </button>
                    )}
                  </div> */}
                  <div className="text-right">
                      <button
                        onClick={() => {

                            const usedPaymentTypeIds = item.multiple_payment.map(
                              mp => mp.payment_type_id
                            );
                            const matchedPayments = paymentList.filter(method =>
                              usedPaymentTypeIds.includes(method.id) // or method.payment_type_id
                            );
                            setPaymentData([...matchedPayments]);
                            const mappedPayments = item.multiple_payment.map(mp => ({
                              methodName: mp.payment_type?.type_name || '',
                              AccountName: mp.payment_type_category?.payment_category_name || '',
                              account_number: mp.payment_type_category?.account_number || '',
                              payment_type_id: mp.payment_type_id || '',
                              payment_type_category_id: mp.payment_type_category_id || '',
                              Amount: mp.payment_amount || '',
                            }));
                            setPaymentAccountAmount(mappedPayments);

                            setTransactionDate(type === "carrier" || type === "exporter"
                              ? formatDate(item.date)
                              : formatDate(item.created_at))
                            setSelectedDuePayment(item);
                            setSelectedIndex(index);
                            setShowPaymentEditModal(true);
                          }
                        }
                        className="text-[#034AFF] text-xs hover:font-bold hover:underline"
                      >
                        Edit
                      </button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      {showPaymentEditModal ? (
        <>
          <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40">
            {/* 🔴 Overlay (transparent dark) */}
            <div
              className="absolute inset-0 bg-black/40"
              onClick={() => setShowPaymentEditModal(false)}
            />
            <div className="relative p-5 z-10 w-full max-w-3xl h-full md:h-auto md:max-h-[90vh] bg-white rounded-2xl shadow-xl overflow-y-auto">
              {/* Header */}
              <div className="sticky top-0 bg-white z-20 border-b px-2 py-3 flex justify-between items-center rounded-t-2xl">
                <h1 className="text-xl font-semibold font-lato">
                  Due Payment Edit
                </h1>

                <button
                  onClick={() => setShowPaymentEditModal(false)}
                  className="text-gray-500 hover:text-red-500 text-xl"
                >
                  ✕
                </button>
              </div>
              <div class="flex flex-row justify-between items-center py-3 px-1">
                <h1 class="text-md font-semibold font-lato pb-1 px-1">Paid Due</h1>
                <div class="">
                  <p class="text-sm px-[4px] py-[2px]">{type === "carrier" || type === "exporter"
                                ? selectedDuePayment?.amount
                                : selectedDuePayment?.paid_amount}</p>
                </div>
              </div>

              <div className="relative border-[#C1CFEF] py-2.5 border w-full flex-1 rounded-xl z-50" onClick={handleDivClick2}>
                        <DatePicker
                          selected={transactionDate}
                          ref={datePickerRef2}
                          onChange={(date) => { setTransactionDate(date); }}
                          dateFormat="dd/MM/yyyy"
                          className="w-full px-2 focus:outline-none z-20"
                        />
                        <span className="bg-white absolute left-2 font-semibold px-1 text-xs top-0 text-[#102048] translate-y-[-50%]">
                          Transaction Date
                        </span>
              </div>

              {paymentList && paymentData?.map((item, index) => (
                <div key={index} className="">
                  {console.log("paymentData................  ",item)}
                  <div className="flex flex-row justify-between items-center py-3 px-1">
                    <h1 className="text-md font-semibold font-lato pb-1 px-1">
                      {paymentAccountAmount[index]?.methodName}
                    </h1>
                    {index != 0 && (
                      <div
                        className="bg-red-600 text-white rounded-md cursor-pointer"
                        onClick={() => handleCancelMethod(item.id, index)}
                      >
                        <p className="text-sm px-[4px] py-[2px]">Cancel</p>
                      </div>
                    )}
                  </div>

                  <div
                    className="flex items-center justify-center py-3 gap-3"
                    onClick={() => setMethodIndex(index)}
                  >
                    <ItemSelectBox
                      name="payment_id"
                      options={paymentList}
                      value={paymentAccountAmount[index]?.payment_type_id}
                      onChange={handleChangeSelect.bind(this, "payment_id")}
                      label={"Method Name"}
                      placeholder={item.type_name}
                      style={{ maxHeight: "300px", overflowY: "scroll" }}
                    />
                  </div>

                  {item.type_name.toLowerCase() != "cash" && (
                    <>
                      <div
                        className="flex items-center justify-center py-3 gap-3"
                        onClick={() => setMethodIndex(index)}
                      >
                        <ItemSelectBox
                          name="account_id"
                          options={filteredAccountList}
                          value={paymentAccountAmount[index]?.payment_type_category_id}
                          label={"Account Name"}
                          onChange={handleChangeSelect.bind(this, "account_id")}
                          placeholder="Select Account"
                        />
                      </div>
                      {console.log("paymentData...Inside Pay due", paymentData)}
                      {console.log("paymentAccountAmount...Inside Pay due", paymentAccountAmount)}
                      {console.log("paymentAccountAmount...Inside Pay due", paymentAccountAmount[index]?.account_number)}
                      <div className="flex items-center justify-center py-3 gap-3">
                        <div className="w-full relative">
                          <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                            Account Number
                          </label>
                          <input
                            type="text"
                            name="name"
                            disabled
                            value={paymentAccountAmount[index]?.account_number}
                            className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <div className="flex items-center justify-center py-2 gap-3">
                    <div className="w-full relative">
                      <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[14px] left-[12px] bg-white px-1 font-semibold">
                        Amount
                      </label>
                      <input
                        type="text"
                        name="name"
                        placeholder="000.0"
                        value={paymentAccountAmount[index]?.Amount || ''}
                        disabled={
                          item.type_name.toLowerCase() == "cash"
                            ? false
                            : paymentAccountAmount[index]?.account_number
                            ? false
                            : true
                        }
                        onChange={(e) => {
                          if (!paymentAccountAmount[index]?.payment_type_id) return;
                          setPaymentAccountAmount((prevAmount) => [
                            ...prevAmount.slice(0, index),
                            { ...prevAmount[index], Amount: e.target.value },
                            ...prevAmount.slice(index + 1),
                          ]);
                        }}
                        className="input input-bordered w-full mb-[10px] rounded-xl bg-white"
                      />
                    </div>
                  </div>

                  {paymentData.length > 1 && <hr />}
                </div>
              ))}
              <div className="flex flex-row justify-between items-center py-3 px-1">
                <div>
                  <h1 className="text-md font-semibold font-lato">
                    Pay with more Method
                  </h1>
                </div>
                <div>
                  <div
                    onClick={handleAddMethod}
                    className="flex justify-center items-center border-2 text-[#000] text-[18px] font-nunito font-bold py-[10px] px-[10px] cursor-pointer rounded-lg capitalize"
                  >
                    <i class="fa-solid fa-plus"></i>
                  </div>
                </div>
              </div>
              <div>
                <button
                  htmlFor="my_modal_due_payment"
                  onClick={(e) => {
                    handleSaveClick(selectedDuePayment)
                  }}
                  className="cursor-pointer w-full bg-[#3559b3] hover:bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </>
        ) : null}
    </>
  );
};

export default PaymentInfo;
